import { useEffect, useState } from "react";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { getGroupPosition } from "../utils/group-position.ts";

export function useGroupPosition(
  idx: number,
  scale: number,
  groupHeight: number,
  baseShift: number,
  isVisible: boolean,
  isGroupHovered: boolean,
) {
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const basePerPixel = useGenomeViewerStore((state) => state.basePerPixel);
  const getOriginOffset = useGenomeViewerStore((state) => state.getOriginOffset);
  const originOffset = -getOriginOffset();

  useEffect(() => {
    if (!isVisible) {
      setPos((prev) => (prev.x === 0 && prev.y === 0 ? prev : { x: 0, y: 0 }));
      return;
    }
    const { x, y } = getGroupPosition(idx, scale, baseShift, basePerPixel, groupHeight, originOffset);
    setPos((prev) => (prev.x === x && prev.y === y ? prev : { x, y }));
  }, [idx, scale, groupHeight, baseShift, basePerPixel, originOffset, isGroupHovered, isVisible]);

  return pos;
}
